import { queries as dynamicLinksQueries } from "domains/admin/containers/DynamicLinks/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: Parameters<typeof dynamicLinksQueries>[0]): Array<WarmableQuery> =>
  dynamicLinksQueries(input);
